<form *dynamicFormInfo="formInfo" (keyup.enter)="search()">
  <div class="row">
    <div class="col-6">
      <app-text-input
        controlName="thirdPartyAdministratorId"
        placeholder="TP-00-0000-000"
        [maskConfig]="inIdMaskConfig"
      ></app-text-input>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="form-search-type-group">
        <app-select-input
          class="form-search-type-select"
          #nameSearchOptionTypeList
          controlName="nameSearchOptionType"
          [showNullPlaceholder]="false"
        ></app-select-input>
        <app-generic-input
          class="form-search-type-input"
          approvedNameCharacters
          controlName="thirdPartyAdministratorName"
        ></app-generic-input>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-4">
      <app-text-input
        #feinTemplate
        controlName="fein"
        [maskConfig]="feinMaskConfig"
        (input)="onFeinChange()"
      ></app-text-input>
    </div>
    <div class="col-4">
      <app-text-input
        controlName="tpaNumber"
        [maskConfig]="tpaNumberMaskConfig"
        (input)="onTpaNumberChange()"
        hint="TPA ID must be formatted as 'T' followed by six digits."
      ></app-text-input>
    </div>
    <div class="col-4">
      <app-select-input
        #thirdPartyAdministratorTypeList
        controlName="thirdPartyAdministratorTypeId"
        [showNullPlaceholder]="false"
      ></app-select-input>
    </div>
  </div>
</form>
